import React from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import QueueAnim from "rc-queue-anim";
import { tryNow } from "../../utils";
import { Title } from "../../components/NewTitle";

export const HomeIdentityInfrastructure = () => {
  const { t } = useTranslation();
  return (
    <div className="home-identity-infrastructure">
      <div className="inner">
        <Title title={t("home.infrastructure.title")} size="h1">
          {t("home.infrastructure.subtitle")}
        </Title>
        <div className="home-application-img">
          <img
            src="//files.authing.co/authing-website/home-identity-infrastructure-v2.png"
            alt="authing home-conection"
          />
        </div>
      </div>
    </div>
  );
};
